import { AxiosError } from 'axios';

interface ApiErrorResponse {
  error?: string;
  message?: string;
  status?: number;
}

export class ApiError extends Error {
  status?: number;
  data?: any;

  constructor(message: string, status?: number, data?: any) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.data = data;
  }
}

export const handleApiError = (error: AxiosError<ApiErrorResponse>): never => {
  if (error.response) {
    // The request was made and the server responded with a status code
    // that falls out of the range of 2xx
    const message = error.response.data?.error || error.response.data?.message || 'An error occurred with the request';
    throw new ApiError(message, error.response.status, error.response.data);
  } else if (error.request) {
    // The request was made but no response was received
    throw new ApiError('No response received from server');
  } else {
    // Something happened in setting up the request that triggered an Error
    throw new ApiError(error.message || 'Error setting up the request');
  }
};

export const getErrorMessage = (error: unknown): string => {
  if (error instanceof ApiError) {
    return error.message;
  }
  if (error instanceof Error) {
    return error.message;
  }
  return 'An unexpected error occurred';
};
